import { PatentIPC } from "./patent-ipc-class";
export default PatentIPC;
